<template>
  <div>
    <div class="d-flex align-items-center flex-row justify-content-between">
      <div>
        <span class="plugin-label">{{ $t(label) }}</span>
        <div class="plugin-description">{{ $t(description) }}</div>
        <div class="d-flex align-items-center">
          <font-awesome-icon
            :icon="['fas', 'check-circle']"
            :class="['icon-state-info mr-1', { active: switchValue }]"
          ></font-awesome-icon>
          <div class="state-info">
            {{ switchValue ? $t(activeText) : $t(disableText) }}
          </div>
        </div>
      </div>
      <el-switch
        v-model="switchValue"
        @change="handleChange"
        size="mini"
        class="pl-2"
      ></el-switch>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'plugin-setting',
  data() {
    return {
      switchValue: true,
    };
  },
  props: {
    label: {
      type: String,
      default: () => '',
    },
    description: {
      type: String,
      default: () => '',
    },
    activeText: {
      type: String,
      default: () => '',
    },
    disableText: {
      type: String,
      default: () => '',
    },

    companyPreference: {
      type: String,
      default: () => '',
    },
    getter: {
      type: String,
      default: () => false,
    },
  },
  created() {
    this.switchValue = this[this.getter] && !!this[this.getter].type;
  },
  // When implementing a new plugin for a company preference, add your getter here
  computed: {
    ...mapGetters([
      'companyAllowCompanyFavoritesPreference',
      'companyApplyExclusiveSearchPreference',
      'companyAllowToastSoundPreference',
      'companySearchUserBoostPreference',
    ]),
  },
  methods: {
    async handleChange(val) {
      return (await val)
        ? this.addCompanyPreferences({
            preferenceType: this.companyPreference,
            preferenceValue: '1',
          })
        : this.deleteCompanyPreferences({
            preferenceIds: [this[this.getter].id],
          });
    },
    ...mapActions(['addCompanyPreferences', 'deleteCompanyPreferences']),
  },
};
</script>

<style lang="scss" scoped>
.plugin-label {
  font-size: 16px;
  line-height: 19px;
  font-weight: 500;
  font-weight: bold;
}
.plugin-description {
  font-size: 12px;
  color: $grey-7-mayday;
}
.icon-state-info {
  color: $grey-4-mayday;
}
.active {
  color: $green-mayday !important;
}
.state-info {
  font-size: 12px;
}
</style>
